import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Alert, Spinner, Table } from "reactstrap";
import escolas, { EscolaSearchResponse } from "../../api/escolas";
import { errorToString } from "../../helpers/funcoes";
import { Titulo } from "../Titulo";

export function EscolaLista() {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<EscolaSearchResponse[]>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setLoading(true);
    escolas
      .search()
      .then((res) => setItems(res.data))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setLoading(false));
    return () => setItems(undefined);
  }, []);

  const onDelete = (
    e: React.MouseEvent<HTMLAnchorElement>,
    nome: string,
    id: string
  ) => {
    e.preventDefault();

    if (!confirm(`Deseja realmente excluir a escola "${nome}"?`)) {
      return;
    }

    setLoading(true);
    setError(undefined);

    escolas
      .remove(id)
      .then(() => escolas.search().then((res) => setItems(res.data)))
      .catch((err) => setError(errorToString(err)))
      .finally(() => setLoading(false));
  };

  if (loading) {
    return (
      <div className="text-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div>
      <Titulo text="Escolas" />
      {error && (
        <Alert color="danger" data-cy="alert">
          {error}
        </Alert>
      )}
      <div className="text-end">
        <Link to="form">Adicionar</Link>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((i) => (
            <tr key={i.id}>
              <td>{i.nome}</td>
              <td className="text-end">
                <Link to={`form/${i.id}`} data-cy={`edit`}>
                  {" "}
                  <FaEdit />
                </Link>
                &nbsp; &nbsp;
                <Link
                  to={`./`}
                  onClick={(e) => onDelete(e, i.nome, i.id)}
                  data-cy={`delete`}
                >
                  <FaTrash />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
